module.exports = __webpack_public_path__ + "static/july-2-a8c6d5469784f5d867a473f4c43a102c.png";